const mutationTypes = {
  SET_AUDIT_OBJECTS: 'SET_AUDIT_OBJECTS',
  SET_EDITED_AUDIT_OBJECT: 'SET_EDITED_AUDIT_OBJECT',
  SET_AUDIT_OBJECT: 'SET_AUDIT_OBJECT',
  SET_LOADING: 'SET_LOADING',
}

const actionTypes = {
  FETCH_AUDIT_OBJECTS: 'FETCH_AUDIT_OBJECTS',
  CREATE_AUDIT_OBJECT: 'CREATE_AUDIT_OBJECT',
  DELETE_AUDIT_OBJECT: 'DELETE_AUDIT_OBJECT',
  UPDATE_AUDIT_OBJECT: 'UPDATE_AUDIT_OBJECT',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/AuditObjectsTypes.js